import React from "react";
import { Box, TextField, Typography, Button } from "@material-ui/core";
import useCommonStyles from "./style";

// The three doshas, in the fixed display order used on the Nadi report card.
const DOSHAS = [
  { key: "vata", label: "Vata" },
  { key: "pitta", label: "Pitta" },
  { key: "kapha", label: "Kapha" },
];

// Comparison operator shown between two adjacent dosha values. Non-numeric
// values (blank fields) collapse to no sign rather than a misleading one.
const compareSign = (a, b) => {
  const x = Number(a);
  const y = Number(b);
  if (a === "" || b === "" || !Number.isFinite(x) || !Number.isFinite(y)) {
    return "";
  }
  return x > y ? ">" : x < y ? "<" : "=";
};

/**
 * Nadi Reading — shows the pulse-derived vata/pitta/kapha values with the
 * live comparison operators (> < =) between them (recomputed as the doctor
 * edits). The three fields are always shown, blank when the patient has no
 * Nadi report yet, so the doctor can record the reading themselves; saving
 * persists to the Nadi Report collection.
 */
const NadiReading = ({ values = {}, onChange, onSave, dirty = false }) => {
  const classes = useCommonStyles();

  return (
    <Box>
      <Box className={classes.nadiWrap}>
        {DOSHAS.map((dosha, index) => (
          <React.Fragment key={dosha.key}>
            <Box className={classes.nadiBox}>
              <Typography className={classes.nadiBoxLabel}>
                {dosha.label}
              </Typography>
              <TextField
                type="number"
                variant="outlined"
                size="small"
                className={classes.nadiInput}
                value={values[dosha.key] ?? ""}
                onChange={(e) => onChange(dosha.key, e.target.value)}
                inputProps={{ min: 0, max: 100, "aria-label": dosha.label }}
              />
            </Box>
            {index < DOSHAS.length - 1 && (
              <Typography className={classes.nadiSign}>
                {compareSign(values[dosha.key], values[DOSHAS[index + 1].key])}
              </Typography>
            )}
          </React.Fragment>
        ))}
      </Box>

      <Box className={classes.hiChatbotActions}>
        <Button
          variant="contained"
          color="primary"
          disableElevation
          className={classes.hiSaveBtn}
          disabled={!dirty}
          onClick={onSave}
        >
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default NadiReading;
